/**
 * 并且可以设置延迟时间，延迟时间内也返回false
 * @param approveTime - 之前保存的时间
 * @param delayDay -延迟天数
 */
import dayjs from "dayjs";
export const isApprovePass = (approveTime, delayDay, showMessage = false) => {
  // 设置延迟
  if (approveTime && delayDay) {
    // 将当前时间减去delayDay天
    const delayDaysAgo = dayjs().subtract(delayDay, "day");
    // 检查给定时间是否在减去delayDay天的当前时间之前
    if (dayjs(approveTime).isBefore(delayDaysAgo)) {
      showMessage && Message.warning(`审批通过${delayDay}天后不能进行此操作`);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/date/date.js